import { useEffect, useState } from "react";
import { NotebookPen, Minus } from "lucide-react";

const Area = ({ value, onChange, rows, testid }) => (
  <textarea
    data-testid={testid}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    rows={rows}
    placeholder="Jot down key findings, calculations (weight-based doses, equipment sizes) and your plan…"
    className="w-full max-h-[30vh] 2xl:max-h-[60vh] rounded-lg p-3 text-sm leading-relaxed resize-y outline-none focus:ring-2"
    style={{ background: "var(--muted-bg)", color: "var(--ink)", border: "1px solid var(--line)" }}
  />
);

export const useNotes = (caseId) => {
  const key = `viva-notes-${caseId}`;
  const [notes, setNotes] = useState(() => sessionStorage.getItem(key) || "");
  useEffect(() => { sessionStorage.setItem(key, notes); }, [key, notes]);
  return [notes, setNotes];
};

export const ReadingNotes = ({ notes, setNotes }) => (
  <section data-testid="reading-notes-box" className="card p-5 sm:p-6 mt-4 fade-up">
    <h2 className="font-display font-semibold flex items-center gap-2"><NotebookPen size={16} style={{ color: "var(--accent)" }} /> Notes</h2>
    <p className="mt-1 mb-3 text-xs" style={{ color: "var(--ink-3)" }}>Use reading time to make notes. They stay with you in a side box for the rest of the viva.</p>
    <Area value={notes} onChange={setNotes} rows={6} testid="reading-notes-input" />
  </section>
);

export const FloatingNotes = ({ notes, setNotes }) => {
  const [open, setOpen] = useState(() => window.innerWidth >= 1536);
  if (!open) {
    return (
      <button data-testid="notes-reopen-button" onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 btn-primary h-12 px-5 rounded-full shadow-lg font-semibold text-sm flex items-center gap-2 fade-up">
        <NotebookPen size={16} /> Notes{notes.trim() ? " •" : ""}
      </button>
    );
  }
  return (
    <aside data-testid="floating-notes-box" className="fixed z-40 bottom-4 right-4 left-4 sm:left-auto sm:w-80 2xl:top-36 2xl:bottom-auto card p-4 shadow-xl fade-up"
      style={{ background: "var(--surface)" }}>
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-display font-semibold text-sm flex items-center gap-2"><NotebookPen size={15} style={{ color: "var(--accent)" }} /> Notes</h2>
        <button data-testid="notes-minimise-button" onClick={() => setOpen(false)} aria-label="Minimise notes"
          className="btn-ghost h-8 w-8 rounded-full grid place-items-center"><Minus size={15} /></button>
      </div>
      <Area value={notes} onChange={setNotes} rows={8} testid="floating-notes-input" />
    </aside>
  );
};
